import { useDispatch } from "react-redux"
import configureStore from "./configureStore"

export const { store, persistor } = configureStore()

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch<any>
export const useAppDispatch = () => useDispatch<AppDispatch>()
